import React from 'react';
import { DatabaseIcon } from 'lucide-react';
import { CSVFileList } from './CSVFileList';
interface CsvExportBlockProps {
  title: string;
  color: 'blue' | 'purple';
  badge: string;
  files: {
    fileName: string;
  }[];
  description: string;
}
export const CsvExportBlock = ({
  title,
  color,
  badge,
  files,
  description
}: CsvExportBlockProps) => {
  const colorClasses = {
    blue: {
      bg: 'bg-blue-50',
      text: 'text-blue-600',
      badge: 'bg-blue-100 text-blue-800'
    },
    purple: {
      bg: 'bg-purple-50',
      text: 'text-purple-600',
      badge: 'bg-purple-100 text-purple-800'
    }
  };
  return <div className="mb-3 border border-gray-200 rounded-md overflow-hidden" data-id="element-10">
      <div className={`${colorClasses[color].bg} p-2 flex items-center justify-between border-b border-gray-200`} data-id="element-11">
        <div className="flex items-center" data-id="element-12">
          <DatabaseIcon className={`${colorClasses[color].text} mr-2`} size={16} data-id="element-13" />
          <span className="font-medium text-gray-700" data-id="element-14">{title}</span>
          <span className={`ml-2 text-xs ${colorClasses[color].badge} px-2 py-0.5 rounded-full`} data-id="element-15">
            {badge}
          </span>
        </div>
      </div>
      <div className="p-3" data-id="element-16">
        <CSVFileList files={files} data-id="element-17" />
        <div className="mt-2 text-xs text-gray-500" data-id="element-18">{description}</div>
      </div>
    </div>;
};